import { Select } from '../../components/forms'

const STATUS_OPTIONS = [
  { value: '', label: 'All Status' },
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
]

const PRIORITY_OPTIONS = [
  { value: '', label: 'All Priority' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
]

function TodoFilters({ filters, onChange, businesses = [] }) {
  const handleChange = (e) => {
    const { name, value } = e.target
    onChange({ ...filters, [name]: value })
  }

  const businessOptions = [
    { value: '', label: 'All Businesses' },
    ...businesses.map(b => ({
      value: b.id,
      label: `${b.emoji} ${b.name}`,
    }))
  ]

  return (
    <div className="flex gap-3 mb-4" style={{ flexWrap: 'wrap' }}>
      <Select
        name="status"
        value={filters.status || ''}
        onChange={handleChange}
        options={STATUS_OPTIONS}
        style={{ minWidth: '140px' }}
      />
      <Select
        name="priority"
        value={filters.priority || ''}
        onChange={handleChange}
        options={PRIORITY_OPTIONS}
        style={{ minWidth: '140px' }}
      />
      <Select
        name="business_id"
        value={filters.business_id || ''}
        onChange={handleChange}
        options={businessOptions}
        style={{ minWidth: '180px' }}
      />
    </div>
  )
}

export default TodoFilters
